<template>
    <div class="patsnap-biz-sequence-viewer">
        <div
            ref="sequenceViewer"
            class="sequence-viewer"
        >
            <div
                ref="sequenceArea"
                class="sequence-area"
                :style="{ 'max-height': maxHeight }"
                @scroll="handleScroll"
            >
                <ul class="l-scale">
                    <li class="scale-baffle" />
                    <li
                        v-for="(data, index) of sequencesProcessed"
                        :key="index"
                    >
                        {{ data.start }}
                    </li>
                </ul>
                <div class="con-box">
                    <div
                        class="sequences"
                        @mouseup.stop="getSelectionEnd"
                        @mousedown.passive="getSelectionStart"
                    >
                        <!--上刻度尺-->
                        <ul
                            v-if="sequencesProcessed.length"
                            class="up-scale"
                        >
                            <li
                                v-for="(s, index) in upScales"
                                :key="index"
                                :style="{ left: s.pos + '%' }"
                            >
                                {{ s.val }}
                            </li>
                        </ul>
                        <div
                            class="sequences-container"
                            @click="handleSearchDomain"
                            @mouseenter.capture="handleMouseEnter"
                        >
                            <template
                                v-for="(item, index) in segmentsAfterProcessed"
                            >
                                <!-- eslint-disable -->
                                <VNode
                                    v-if="
                                        !enableHover ||
                                            !item.highlightNos.length
                                    "
                                    :key="index"
                                    :style="{ color: item.useHighlightColor }"
                                    :nodes="cachedSequences[index]"
                                />
                                <!-- eslint-disable -->
                                <span
                                    v-else
                                    :key="index"
                                    class="highlight-area"
                                >
                                    <span class="highlight-hover-tooltip">
                                        <span
                                            class="highlight-hover-tooltip__inner"
                                            :data-no="item.useHighLight"
                                        >
                                            {{
                                                hoverTooltip
                                                    ? hoverTooltip(
                                                          item.useHighLight
                                                      )
                                                    : ""
                                            }}：{{ searchButtonText }}</span
                                        >
                                    </span>
                                    <VNode
                                        :style="{
                                            color: item.useHighlightColor
                                        }"
                                        :nodes="cachedSequences[index]"
                                    />
                                </span>
                            </template>
                            <!-- eslint-disable -->
                            <span
                                v-if="singleRowPadding"
                                v-html="singleRowPadding"
                            />
                            <!-- eslint-disable -->
                        </div>
                    </div>
                </div>
                <ul class="r-scale">
                    <li class="scale-baffle" />
                    <li
                        v-for="(data, index) of sequencesProcessed"
                        :key="index"
                    >
                        {{ data.end }}
                    </li>
                </ul>

                <!--查询按钮 浮动-->
                <ElButton
                    v-show="searchBtnVisible && shouldShowSearchBtn"
                    :style="{ top: searchTop + 'px', left: searchLeft + 'px' }"
                    class="search-btn"
                    ref="searchBtn"
                    @click="search"
                >
                    {{ $t("seqViews.searchBtn") }}
                </ElButton>
            </div>
            <div v-if="!sequence" class="no-sequence">
                {{ $t("seqViews.noSequence") }}
            </div>
        </div>
        <!-- 对齐到元素共享统一弹窗实例的典型 -->
        <!-- 出现popover需满足： -->
        <!-- 有data-no包裹，并且内部定义了data-highlight-target -->
        <ElPopover
            v-if="hoverOptions && hoverOptions.highlightTarget"
            ref="popover"
            trigger="hover"
            v-model="popoverVisible"
            placement="top-start"
            :visible-arrow="false"
            :reference="popoverReference"
            :key="hoverKey"
        >
            <div class="patsnap-biz-sequence_viewer__popover-spacer">
                <slot name="popover" v-bind="computedHoverOptions">
                    <VNode :nodes="computedHoverOptions.node" />
                </slot>
            </div>
        </ElPopover>
    </div>
</template>

<script>
import { padEnd, toNumber } from 'lodash';
import Button from 'element-ui/lib/button';
import Popover from 'element-ui/lib/popover';
import { calculate, transferHitToHighlight, splitIntoSegments } from './SegmentProcess';
import { slotRender } from './slotRender';
import { VNode } from './vNode';
import { BLANK, LINE_LENGTH } from './constants';

let cancelFnTemp = null;

// todo 剔除degenerate逻辑
export default {
    name: 'PtSequenceViewer',
    slotRender,
    components: {
        ElButton: Button,
        ElPopover: Popover,
        VNode,
    },
    props: {
        sequence: {
            type: String,
            required: true,
        },
        sequenceType: {
            type: String,
            required: true,
        },
        segmentLength: {
            type: Number,
            default: 60,
        },
        disabledSelectSearch: {
            type: Boolean,
            default: false,
        },
        hits: {
            type: Array,
            default: () => [],
        },
        /*
        * 示例：[{
            start: 10,
            end: 25,
            color: '#f00',
            no: 1
        }]
        */
        highlights: {
            type: Array,
            default: () => [],
        },
        // 计算hover的tooltip里要展示的内容
        hoverTooltip: {
            type: Function,
            default: () => {},
        },
        maxHeight: {
            type: String,
            default: '500px',
        },
        enableHover: {
            type: Boolean,
            default: false,
        },
        degenerateCodes: {
            type: Array,
            default() {
                return [];
            },
        },
        shouldShowSearchBtn: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            startTop: 0,
            startLeft: 0,
            endTop: 0,
            endLeft: 0,
            searchBtnVisible: 0, // 查询按钮
            searchTop: 0,
            searchLeft: 0,
            popoverReference: null, // popover对齐的元素
            popoverVisible: false,
            hoverOptions: null,
            loadedLines: Math.ceil(this.maxHeight.replace('px', '') / LINE_LENGTH) + 5,
            isLoading: false,
        };
    },
    computed: {
        totalLines() {
            return Math.ceil(this.sequence.length / LINE_LENGTH);
        },
        operateSequence() {
            return this.sequence.slice(0, this.loadedLines * this.segmentLength);
        },
        /**
         * 当前高度能显示的最多行数
         * @returns {number}
         */
        perViewLines() {
            return Math.ceil(this.maxHeight.replace('px', '') / LINE_LENGTH);
        },
        activeHighlight() {
            if (this.hits && this.hits.length) {
                return transferHitToHighlight(this.hits);
            }
            return this.highlights;
        },
        sequencesProcessed() {
            // 如果是一行补齐空格
            return splitIntoSegments(this.operateSequence, this.segmentLength);
        },
        segmentsAfterProcessed() {
            return calculate(
                this,
                this.operateSequence,
                this.activeHighlight,
                this.segmentLength,
                this.degenerateNos,
            );
        },
        cachedSequences() {
            return this.segmentsAfterProcessed.map((i) => i.formattedSequence);
        },
        singleRowPadding() {
            const isSingleRow = this.operateSequence.length < this.segmentLength;
            if (isSingleRow) {
                const num = this.segmentLength - this.operateSequence.length;
                const splitSpace = parseInt(num / 10, 10);
                return padEnd('', num + splitSpace, '^').replaceAll('^', BLANK);
            }
            return '';
        },
        searchButtonText() {
            return this.$t('seqViews.searchBtn');
        },
        upScales() {
            const scales = [];
            let length = this.segmentLength;
            const spaceInterval = 10;
            const count = parseInt(this.segmentLength / spaceInterval, 10) - 1;
            let index = 1;
            while (length > 10) {
                const val = (scales.length + 1) * 10;
                scales.push({
                    val,
                    pos: (
                        ((val + index - 0.5) / (this.segmentLength + count))
                        * 100
                    ).toFixed(1),
                });
                length -= 10;
                // eslint-disable-next-line
                index++;
            }
            return scales;
        },
        degenerateNos() {
            // 后端从0开始计数
            return this.degenerateCodes.map((x) => x.location);
        },
        popoverTargets() {
            if (!(this.hoverOptions && this.hoverOptions.highlightTarget)) return [];
            return this.hoverOptions.highlightTarget.split(',');
        },
        computedHoverOptions() {
            return {
                ...this.hoverOptions,
                highlightTarget: this.popoverTargets,
                node: null,
            };
        },
        hoverKey() {
            return this.hoverOptions
                ? this.hoverOptions.location
                : Math.random();
        },
    },
    mounted() {
        cancelFnTemp = this.cancelSelection.bind(this);
        document.body.addEventListener('mouseup', cancelFnTemp);
    },
    beforeDestroy() {
        document.body.removeEventListener('mouseup', cancelFnTemp);
    },
    methods: {
        getDistance2Top(e) {
            const domSeq = this.$refs.sequenceArea;
            const pos = domSeq.getBoundingClientRect();
            return domSeq.scrollTop + e.clientY - pos.top;
        },
        getDistance2Left(e) {
            const domSeq = this.$refs.sequenceArea;
            const pos = domSeq.getBoundingClientRect();
            return e.clientX - pos.left - 20;
        },
        getSelectionStart(e) {
            if (this.disabledSelectSearch) return;
            this.searchBtnVisible = 0;
            this.startTop = this.getDistance2Top(e);
            this.startLeft = this.getDistance2Left(e);
        },
        getSelectionEnd(e) {
            if (this.disabledSelectSearch) return;
            const selection = window.getSelection();
            const selText = selection
                .toString()
                .split('\n')
                .join('')
                .replace(/\s/g, '');
            if (!selText.length) return;
            const domSeq = this.$refs.sequenceArea;
            const pos = domSeq.getBoundingClientRect();
            this.endTop = this.getDistance2Top(e);
            this.endLeft = this.getDistance2Left(e);

            // mousedown和up在同一个点 判断为未选择文本
            if (
                this.endTop === this.startTop
                    && this.startLeft === this.endLeft
            ) {
                return;
            }

            // 考虑双击选中的情况
            // 距离过近如何处理 重叠重新计算
            const distance2top = this.endTop;
            const offset = this.endTop > this.startTop ? -30 : 10;

            // 查询按钮
            this.searchTop = distance2top + offset;
            this.searchLeft = e.clientX - pos.left + 5;

            this.searchBtnVisible = 1;
        },
        cancelSelection(e) {
            // 点击选择区域外的地方 取消选中
            const domSearch = this.$refs.searchBtn.$el;
            if (domSearch && domSearch.contains(e.target)) return;
            this.searchBtnVisible = 0;
        },
        async search() {
            const selection = window.getSelection();
            let selText = selection.toString();
            if (!selText.length) return;
            selText = selText.replace(/\s/g, '');
            this.$emit('search-sequence', {
                selText,
                sequenceType: this.sequenceType,
            });
        },
        handleSearchDomain(e) {
            if (e.target.className === 'highlight-hover-tooltip__inner') {
                const light = this.activeHighlight[
                    parseInt(e.target.getAttribute('data-no'), 10)
                ];
                const selText = this.operateSequence.substr(
                    light.start - 1,
                    light.end - light.start + 1,
                );
                this.$emit('search-sequence', {
                    selText,
                    sequenceType: this.sequenceType,
                });
            }
        },
        findDataNode(el) {
            let current = el;
            try {
                do {
                    if (
                        current.hasAttribute
                        && current.hasAttribute('data-no')
                    ) {
                        return current;
                    }
                    if (current.classList.contains('sequences-container')) {
                        return null;
                    }
                    current = current.parentElement;
                } while (current);
            } catch (e) {
                // noop
            }
            return null;
        },
        getDataNodeOptions(target) {
            const opt = {};
            const getOption = (el) => {
                try {
                    const keys = Object.keys(el.dataset);
                    keys.forEach((k) => {
                        if (k.startsWith('highlight')) {
                            if (k in opt) {
                                opt[k] += `,${el.dataset[k]}`;
                            } else {
                                opt[k] = el.dataset[k];
                            }
                        } else if (k === 'no') {
                            opt.location = toNumber(el.dataset[k]);
                            opt.no = opt.location;
                        }
                    });
                    const kids = el.children ? [...el.children] : [];
                    if (kids.length > 0) {
                        kids.forEach((kid) => getOption(kid));
                    }
                } catch (e) {
                    // skip
                }
            };
            getOption(target);
            return opt;
        },
        handleMouseEnter(e) {
            const bindDom = this.findDataNode(e.target);
            if (bindDom) {
                const options = this.getDataNodeOptions(bindDom);
                if (options && options.highlightTarget) {
                    this.hoverOptions = options;
                    this.popoverReference = bindDom;
                    this.$nextTick(() => {
                        this.$refs.popover.updatePopper();
                        this.popoverVisible = true;
                    });
                }
            }
        },
        handleScroll(e) {
            const { scrollTop, scrollHeight, clientHeight } = e.target;

            // 计算滚动位置的百分比
            const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

            // 如果滚动接近底部且未达到总行数上限且当前没有正在加载，则加载更多
            if (
                scrollPercentage > 0.8 && this.loadedLines < this.totalLines && !this.isLoading
            ) {
                this.loadMore();
            }
        },
        loadMore() {
            this.isLoading = true;

            requestAnimationFrame(() => {
                this.loadedLines = Math.min(this.loadedLines + this.perViewLines, this.totalLines);
                this.isLoading = false;
            });
        },
    },
};
</script>
